module.exports = __webpack_public_path__ + "media/images/homes/TakeOut-cbee6fa5d4480b1d09aa40072f9b7ece.png";